// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fannotations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { AnnotationState } from '../../annotations';
import { Annotation, BinaryClassificationAnnotation, StreamAnnotation } from '../annotations.g';
import { schemaObjectHeaderValidatorInstance, schemaObjectValidatorInstance } from '../../generated/validator/schema-object-validator.g';
import { validateArray } from '@augloop/validator-common';
export class AnnotationMetaDataValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationMetaData: Expected object, got undefined object for AnnotationMetaDataValidator' };
        }
        if ((obj.state !== undefined)) {
            const result = annotationStateValidatorInstance.validate(obj.state);
            if (!result.success) {
                result.error = "AnnotationMetaData.state: " + result.error;
                return result;
            }
        }
        if ((obj.shareable !== undefined) && (typeof obj.shareable !== 'boolean')) {
            return { success: false, error: 'AnnotationMetaData: Optional field "shareable" is wrong type' };
        }
        if ((obj.customMetadata !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.customMetadata);
            if (!result.success) {
                result.error = "AnnotationMetaData.customMetadata: " + result.error;
                return result;
            }
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'AnnotationMetaData: Optional field "seq" is wrong type' };
        }
        if ((obj.sourceTimestamp !== undefined) && (typeof obj.sourceTimestamp !== 'number')) {
            return { success: false, error: 'AnnotationMetaData: Optional field "sourceTimestamp" is wrong type' };
        }
        return { success: true };
    }
}
export const annotationMetaDataValidatorInstance = new AnnotationMetaDataValidator();
export class AnnotationActivationConfigsValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationActivationConfigs: Expected object, got undefined object for AnnotationActivationConfigsValidator' };
        }
        if (obj.annotationType === undefined) {
            return { success: false, error: 'AnnotationActivationConfigs: Required field "annotationType" is missing' };
        }
        else if (typeof obj.annotationType !== 'string') {
            return { success: false, error: 'AnnotationActivationConfigs: Required field "annotationType" is wrong type' };
        }
        if (obj.configs === undefined) {
            return { success: false, error: 'AnnotationActivationConfigs: Required field "configs" is missing' };
        }
        else {
            const result = validateArray(obj.configs, 1, schemaObjectValidatorInstance, '{SchemaObject}');
            if (!result.success) {
                result.error = "AnnotationActivationConfigs.configs: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const annotationActivationConfigsValidatorInstance = new AnnotationActivationConfigsValidator();
export class AnnotationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Annotation: Expected object, got undefined object for AnnotationValidator' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'Annotation: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'Annotation: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'Annotation: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "Annotation.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "Annotation.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Annotation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Annotation"' };
        }
        return { success: true };
    }
}
export const annotationValidatorInstance = new AnnotationValidator();
export class BinaryClassificationAnnotationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BinaryClassificationAnnotation: Expected object, got undefined object for BinaryClassificationAnnotationValidator' };
        }
        if (obj.name === undefined) {
            return { success: false, error: 'BinaryClassificationAnnotation: Required field "name" is missing' };
        }
        else if (typeof obj.name !== 'string') {
            return { success: false, error: 'BinaryClassificationAnnotation: Required field "name" is wrong type' };
        }
        if (obj.value === undefined) {
            return { success: false, error: 'BinaryClassificationAnnotation: Required field "value" is missing' };
        }
        else if (typeof obj.value !== 'boolean') {
            return { success: false, error: 'BinaryClassificationAnnotation: Required field "value" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'BinaryClassificationAnnotation: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'BinaryClassificationAnnotation: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'BinaryClassificationAnnotation: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "BinaryClassificationAnnotation.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "BinaryClassificationAnnotation.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!BinaryClassificationAnnotation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "BinaryClassificationAnnotation"' };
        }
        return { success: true };
    }
}
export const binaryClassificationAnnotationValidatorInstance = new BinaryClassificationAnnotationValidator();
export class StreamAnnotationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'StreamAnnotation: Expected object, got undefined object for StreamAnnotationValidator' };
        }
        if (obj.seqId === undefined) {
            return { success: false, error: 'StreamAnnotation: Required field "seqId" is missing' };
        }
        else if (typeof obj.seqId !== 'number') {
            return { success: false, error: 'StreamAnnotation: Required field "seqId" is wrong type' };
        }
        if (obj.isFinalResponse === undefined) {
            return { success: false, error: 'StreamAnnotation: Required field "isFinalResponse" is missing' };
        }
        else if (typeof obj.isFinalResponse !== 'boolean') {
            return { success: false, error: 'StreamAnnotation: Required field "isFinalResponse" is wrong type' };
        }
        if ((obj.isFirstUserPerceivedResponse !== undefined) && (typeof obj.isFirstUserPerceivedResponse !== 'boolean')) {
            return { success: false, error: 'StreamAnnotation: Optional field "isFirstUserPerceivedResponse" is wrong type' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'StreamAnnotation: Optional field "id" is wrong type' };
        }
        if ((obj.ownerId !== undefined) && (typeof obj.ownerId !== 'string')) {
            return { success: false, error: 'StreamAnnotation: Optional field "ownerId" is wrong type' };
        }
        if ((obj.invalidationHash !== undefined) && (typeof obj.invalidationHash !== 'string')) {
            return { success: false, error: 'StreamAnnotation: Optional field "invalidationHash" is wrong type' };
        }
        if ((obj.M_ !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "StreamAnnotation.M_: " + result.error;
                return result;
            }
        }
        if ((obj.metadata !== undefined)) {
            const result = annotationMetaDataValidatorInstance.validate(obj.metadata);
            if (!result.success) {
                result.error = "StreamAnnotation.metadata: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!StreamAnnotation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "StreamAnnotation"' };
        }
        return { success: true };
    }
}
export const streamAnnotationValidatorInstance = new StreamAnnotationValidator();
export class AnnotationStateValidator {
    validate(value) {
        if (!AnnotationStateValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "AnnotationState"' };
        }
        return { success: true };
    }
}
AnnotationStateValidator.validValues = new Set([AnnotationState.Undefined, AnnotationState.Created, AnnotationState.Sent, AnnotationState.Duplicated, AnnotationState.Seen, AnnotationState.Tried, AnnotationState.Kept, AnnotationState.Rejected]);
export const annotationStateValidatorInstance = new AnnotationStateValidator();
//# sourceMappingURL=annotations-validator.g.js.map